module.exports = __webpack_public_path__ + "static/media/id_clave.ac26371d.svg";